export default __webpack_public_path__ + "static/media/local-code-analysis.bad44f85.png";